export default __webpack_public_path__ + "static/media/jony.08fd32c8.jpg";